import { render, staticRenderFns } from "./TwoFactorAuthTab.vue?vue&type=template&id=a362b880&"
import script from "./TwoFactorAuthTab.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports